import React from 'react';
import { WarningBanner } from '@app/react-common/components/banners/WarningBanner';
import Link from '@app/react-common/components/link/Link';
import useShop from '@app/react-common/hooks/useShop';

const themeEditorLinkStyle = {
  color: 'var(--primary-default)',
  textDecoration: 'none',
};

export const PdpWinnerSuccessContent: React.FC = () => {
  const shop = useShop();
  const themeEditorUrl = shop?.name ? `https://${shop.name}/admin/themes/current/editor?template=product` : undefined;

  return (
    <div className="pdp-winner-success-content">
      <WarningBanner
        title="Winner recorded — make your winning variation live"
        content={`Your winning PDP variation has been saved, but no changes were made to your store. To go live, make sure the widget is on your product page and set the winning product promise to Live.`}
        hideCloseButton={true}
        variant="attention"
      />

      <div className="pdp-winner-success-content__steps">
        <div className="pdp-winner-success-content__step">
          <div className="pdp-winner-success-content__step-number">1</div>
          <div className="pdp-winner-success-content__step-content">
            <h5 className="pdp-winner-success-content__step-title">Add widget to your product page</h5>
            <p className="pdp-winner-success-content__step-description">Choose one of the following options:</p>
            <div className="pdp-winner-success-content__step-options">
              <div className="pdp-winner-success-content__step-option">
                <h6 className="pdp-winner-success-content__step-option-title">Option A: Add with Theme Editor</h6>
                <p className="pdp-winner-success-content__step-option-description">
                  Drag & drop the widget on your product page in the{' '}
                  {themeEditorUrl ? (
                    <>
                      <Link
                        label="Theme Editor"
                        url={themeEditorUrl}
                        external={true}
                        className="pdp-winner-success-content__theme-editor-link"
                        customStyle={themeEditorLinkStyle}
                      />
                      <img
                        src="/assets/icons/external.svg"
                        alt="External link"
                        className="pdp-winner-success-content__external-icon"
                      />
                    </>
                  ) : (
                    'Theme Editor'
                  )}{' '}
                  (requires Online Store 2.0)
                </p>
              </div>
              <div className="pdp-winner-success-content__step-option">
                <h6 className="pdp-winner-success-content__step-option-title">Option B: Add with code</h6>
                <p className="pdp-winner-success-content__step-option-description">
                  Go to your winning product promise in PDQ, copy its tag, and paste it into your product page code.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="pdp-winner-success-content__step">
          <div className="pdp-winner-success-content__step-number">2</div>
          <div className="pdp-winner-success-content__step-content">
            <h5 className="pdp-winner-success-content__step-title">Set your winning product promise to Live</h5>
            <p className="pdp-winner-success-content__step-description">
              Go to Product Promise in PDQ and set the winning variation to Live.
            </p>
          </div>
        </div>

        <div className="pdp-winner-success-content__step">
          <div className="pdp-winner-success-content__step-number">3</div>
          <div className="pdp-winner-success-content__step-content">
            <h5 className="pdp-winner-success-content__step-title">Update your checkout groups in PDQ</h5>
            <p className="pdp-winner-success-content__step-description">
              if you mapped checkout groups to this test, set the winning group to Live. Turn off any groups tied to the
              losing variation.
            </p>
          </div>
        </div>

        <div className="pdp-winner-success-content__step">
          <div className="pdp-winner-success-content__step-number">4</div>
          <div className="pdp-winner-success-content__step-content">
            <h5 className="pdp-winner-success-content__step-title">Verify everything is working</h5>
            <p className="pdp-winner-success-content__step-description">
              Visit a product page on your storefront to confirm the winning product promise is displaying correctly.
            </p>
          </div>
        </div>
      </div>

      <p className="pdp-winner-success-content__footer">
        Your test results and ROI data will stay available in PDQ for future reference.
      </p>
    </div>
  );
};
